/*
 * Anonymous browser-scoped client identity. Same key the prototype HTMLs
 * use (motr_client_id) — preserved verbatim so existing buyers who
 * visited a prototype keep the same id when they hit the production
 * tools. Critical for cross-tool journey stitching in analytics.
 *
 * Only generates a new UUID when none exists. Never regenerates — that
 * would break the retroactive contact-attribution path the marketing
 * roadmap depends on.
 */

const KEY = 'motr_client_id';

export function getClientId(): string {
  let existing = readSafe();
  if (existing) return existing;
  existing = generateUuid();
  writeSafe(existing);
  return existing;
}

function readSafe(): string | null {
  try {
    return localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

function writeSafe(value: string): void {
  try {
    localStorage.setItem(KEY, value);
  } catch {
    /* Private mode / disabled storage — fall back to in-memory id for
       the session. Submissions will still work but cross-session
       stitching is lost. */
  }
}

function generateUuid(): string {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return crypto.randomUUID();
  }
  // Fallback for older browsers: RFC 4122 v4 via Math.random.
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
